export default __webpack_public_path__ + "cec874526696718ed8fd6756e192f7ed.svg";